<div class="card-view-container aza-pa-grid aza-pa-two-columns-grid-full-width-columns aza-pa-flex-item-align-normal">
    <div *ngFor="let iconData of localData" class="card-container aza-pa-padding mat-elevation-z2">
        <div class="card-title aza-pa-flex-row aza-pa-content-space-between">
            <h2 class="aza-pa-primary-color">{{iconData.name}}</h2>
            <button (click)="onCardMenuSelected(iconData)" mat-icon-button
                [matMenuTriggerFor]="actionsMenu">
                <mat-icon>more_vert</mat-icon>
            </button>
        </div>
        <div class="card-content aza-pa-flex-row">
            <div class="card-thumbnail">
                <img [src]="iconData.thumbnailSrc" class="thumbnail-image aza-pa-full-width" />
            </div>
        </div>
    </div>
    <mat-menu #actionsMenu="matMenu">
        <button *ngFor="let action of actions" [disabled]="getActionMenuItemDisabledState(action)"
            (click)="onCardMenuActionSelected(action)" mat-menu-item>
            <mat-icon color="primary">{{action.icon}}</mat-icon>
            <span>{{action.label}}</span>
        </button>
    </mat-menu>
</div>
